export default __webpack_public_path__ + "static/media/no-gps-alt.29536f27.svg";